import { ReactNode, useRef } from 'react'

import { CopyIcon } from '@radix-ui/react-icons'

import useClipboard from 'hooks/use-clipboard'

import Box from 'components/atomic/atoms/box'
import { IconStyled } from 'components/atomic/atoms/icon'
import Text from 'components/atomic/atoms/text'
import Tooltip from 'components/atomic/atoms/tooltip'
import { PreStyled } from 'components/atomic/molecules/code-block'

type CodeProps = {
  children: ReactNode
  className?: string
}

const SharedCode = props => {
  const codeProps = props?.children?.props as CodeProps | undefined
  const preRef = useRef<HTMLPreElement>(null)
  const { hasCopied, onCopy } = useClipboard()
  const copy = () => onCopy(preRef.current?.textContent ?? '')

  return (
    <Box
      relative
      css={{
        '& > div:first-child': {
          opacity: 0,
          transition: '.2s ease-in',
        },
        '&:hover > div:first-child': {
          opacity: 1,
        },
      }}
    >
      <Box
        absolute
        flex
        items="center"
        justify="between"
        css={{
          right: '$2',
          top: '$2',
        }}
      >
        <Tooltip text="Copy">
          <Box
            flex
            items="start"
            justify="start"
            as="button"
            aria-label={hasCopied ? 'Copied' : 'Copy'}
            onClick={copy}
          >
            {hasCopied ? (
              <Text size="xs" color="accent">
                Copied!
              </Text>
            ) : (
              <IconStyled as={CopyIcon} color="text2" size="md" />
            )}
          </Box>
        </Tooltip>
      </Box>
      <PreStyled
        ref={preRef}
        css={{
          backgroundColor: '$bg',
          py: '$4',
          borderRadius: '$lg',
          border: '1px solid $bg3',
        }}
      >
        <code {...codeProps} />
      </PreStyled>
    </Box>
  )
}

export default SharedCode
